export class LangConstant {
  static LANG_KR = "kr";
  static LANG_EN = "en";
  static KR = "KR";
  static EN = "EN";
  static STR_LANG = "lang";
}